import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler } from 'utils';

import discoverProvinceApi from 'api/discoverProvince';
import { GET_DISCOVERY_PROVINCES, GET_DISCOVERY_PROVINCE_DETAILS, GET_PROVINCES_NAME } from './actionTypes';
import {
  actionGetDiscoveryProvinceDetailsFailed,
  actionGetDiscoveryProvinceDetailsSuccess,
  actionGetDiscoveryProvincesFailed,
  actionGetDiscoveryProvincesSuccess,
  actionGetProvincesNameFailed,
  actionGetProvincesNameSuccess,
} from './actions';

function* getDiscoveryProvinces({ payload }) {
  try {
    const r = yield discoverProvinceApi.getDiscoverProvinces(payload);
    yield put(actionGetDiscoveryProvincesSuccess(r.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoveryProvincesFailed());
  }
}

function* getDiscoveryProvinceDetails({ payload }) {
  try {
    const r = yield discoverProvinceApi.getDiscoverProvinceDetails(payload);
    yield put(actionGetDiscoveryProvinceDetailsSuccess(r.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoveryProvinceDetailsFailed());
  }
}

function* getProvincesName() {
  try {
    const r = yield discoverProvinceApi.getProvincesName();
    yield put(actionGetProvincesNameSuccess(r.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetProvincesNameFailed());
  }
}

export default function* discoverProvince() {
  yield takeLeading(GET_DISCOVERY_PROVINCES, getDiscoveryProvinces);
  yield takeLeading(GET_DISCOVERY_PROVINCE_DETAILS, getDiscoveryProvinceDetails);
  yield takeLeading(GET_PROVINCES_NAME, getProvincesName);
}
